import React, { Component } from 'react'
import { Table } from 'hljd'
import { observer } from 'mobx-react'
import columns from './columns'
import { toJS } from 'mobx'
@observer
export default class extends Component {
  render() {
    const { store } = this.props
    const { detail, title } = store
    return (
      <div style={{ marginBottom: 26 }}>
        <div style={{ color: '#333', fontSize: 16, marginBottom: 22 }}>
          {title}
        </div>
        <Table
          rowKey={(record, index) => index}
          dataSource={toJS(detail)}
          columns={columns(store)}
          pagination={false}
        />
      </div>
    )
  }
}
